'use client'

import dynamic from 'next/dynamic'
import React, { useEffect, useState } from 'react'

export const ClientOnly = dynamic(
  () =>
    Promise.resolve(({ children, fallback }: { children: React.ReactNode; fallback?: React.ReactNode }) => {
      if (typeof window === 'undefined') {
        return fallback ?? null
      }

      return children
    }),
  { ssr: false },
)

export const ClientOnlyV2 = ({ children, fallback }: { children: React.ReactNode; fallback?: React.ReactNode }) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return fallback
  }

  return children
}
